import _ from 'lodash';

import { Metadata } from '../types';

import {
  Path, RawVideo, Video,
} from './types';

// Converts topic string in the form of #chem#mod1#atom into form
// suitable for Breadcrumbs with labels set as an empty string
export const toPath =
(topic: string | undefined, pathLabels: string[] | undefined): Path[] => {
  let output: Path[] = [];

  if (topic && pathLabels) {
    const keys = topic.split('#');

    // Keys are only three levels deep (subject, category, topic) at most, but this
    // function works for a more general case of only up to the subejct or the category
    // being specified
    for (let i = 0; i < Math.min(keys.length, 3); i++) {
      const queryParams = ['subject', 'category', 'topic'];
      let href: string = '/videos?';
      for (let k = 0; k <= i; k++) {
        if (keys[k]) {
          if (k > 0 && keys[k - 1]) {
            href = href.concat('&');
          }
          href = href.concat(`${queryParams[k]}=${keys[k]}`);
        }
      }
      output = output.concat({
        href, label: pathLabels[i], key: keys[i],
      });
    }
  }

  return output;
};

export const toVideo = ({ data, metadata }: {
  data: RawVideo,
  metadata: Metadata
}): {
  data: Video,
  metadata: Metadata
} => ({
  data: ({
    ..._.pick(data, [
      'subject',
      'videoId',
      'topic',
      'youtubeId',
      'title',
      'description',
      'host',
      'resources',
      'topicVideos',
      'relatedVideos',
      'topicResources',
    ]),
    id: data.videoId,
    path: toPath(data.topic, data.pathLabels),
    uploadDatetime: data.creationDatetime,
  }),
  metadata: {
    ...metadata,
    id: {
      hide: true,
      label: 'ID',
      type: 'text',
      editable: false,
    },
    path: {
      hide: true,
      label: 'Path',
      type: 'text',
      editable: false,
    },
    uploadDatetime: metadata?.creationDatetime,
  },
});

export const toVideos = ({ data, metadata }: {
  data: RawVideo[],
  metadata: Metadata
}): {
  data: Video[],
  metadata: Metadata
} => ({
  data: data.map((video) => ({
    ..._.pick(video, [
      'subject',
      'videoId',
      'topic',
      'youtubeId',
      'title',
      'description',
      'host',
      'resources',
      'topicVideos',
      'relatedVideos',
      'topicResources',
    ]),
    id: video.videoId,
    path: toPath(video.topic, video.pathLabels),
    uploadDatetime: video.creationDatetime,
  })),
  metadata: {
    ...metadata,
    id: {
      hide: true,
      label: 'ID',
      type: 'text',
      editable: false,
    },
    path: {
      hide: true,
      label: 'Path',
      type: 'text',
      editable: false,
    },
    uploadDatetime: metadata?.creationDatetime,
  },
});
